import { render, staticRenderFns } from "./AxRowCenter.vue?vue&type=template&id=e3b179b2"
import script from "./AxRowCenter.vue?vue&type=script&lang=ts"
export * from "./AxRowCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports